module.exports = __webpack_public_path__ + "static/media/ic-regframe.4629cb49.svg";